//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { removeReport } from '@/utils/report';

export default {
  data() {
    return {
      removeReport,
    };
  },
  mounted() {},
  methods: {
    cnacle() {
      if (this.cancleFunc) {
        this.cancleFunc();
      }
      removeReport('confirm');
    },
    confirm() {
      if (this.confirmFunc) {
        this.confirmFunc();
      }
      removeReport('confirm');
    },
  },
};
